module.exports = __webpack_public_path__ + "static/media/menuHeart.ffc2e399.svg";